import { IProductReference } from '@epicuro-next/data/product';
import { Product } from 'graphql-api/gql-api-interfaces';

function mapProductReferencesAvailability(
  products: IProductReference[],
  isAvailable: boolean,
) {
  return products.map(({ productId }) => ({
    productId,
    isAvailable,
  }));
}

export const productReferencesAvailabilityHandler = (
  availableProductReferences: IProductReference[],
  unavailableProductReferences: IProductReference[],
  products: Product[],
) => {
  const availableProducts = mapProductReferencesAvailability(
    availableProductReferences,
    true,
  );

  const unavailableProducts = mapProductReferencesAvailability(
    unavailableProductReferences,
    false,
  );

  const checkedProductsAvailability = [
    ...availableProducts,
    ...unavailableProducts,
  ];

  return checkedProductsAvailability.map(
    ({ productId: checkedProductId, isAvailable }) => {
      const product = products.find(
        ({ productId }) => productId === checkedProductId,
      );
      return { ...product, isAvailable };
    },
  );
};
